import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { IonContent, Platform } from "@ionic/angular";
import { Navigator } from "src/app/components/menu/navigator";
import { gsap } from 'gsap';
//Paid plugin added. Do not comment below plugins. You just need to remove node_modules and have to do npm i again.
import { MotionPathHelper } from 'gsap/MotionPathHelper'; // Import the MotionPathPlugin
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
import { LeaderboardService } from "src/app/services/leaderboard/leaderboard.service";
import { AccountBalanceService } from "src/app/services/balance/account-balance.service";
import { AudioService } from "src/app/services/audio/audio.service";
import { BonusContent } from "src/app/popovers/bonus-content/bonus-content.page";
gsap.registerPlugin(MotionPathHelper, MotionPathPlugin); // Register the MotionPathPlugin

@Component({
	selector: 'app-leaderboard-tutorial',
	templateUrl: './leaderboard-tutorial.component.html',
	styleUrls: ['./leaderboard-tutorial.component.scss'],
})

export class LeaderboardTutorialComponent implements OnInit {
	@ViewChild(IonContent, { static: false }) content: IonContent;
	private isPortrait: boolean = false;
	isMobile: any;
	currentSlide: number;
	isLandscape: any;
	openCancelFlag: boolean = false;
	private autoHideCount: number = 6000;
	constructor(public navigator:Navigator,
		private leaderboardService:LeaderboardService,
		private balanceProvider:AccountBalanceService,
		private audioService: AudioService,
		private platform:Platform
	) { 
		this.adjustCSSForMobile();
		this.currentSlide = 1;
	}


	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
	  setTimeout(() => {
		this.adjustCSSForMobile();
	  }, 500);
	}


	ngOnInit(): void {
	}


	checkImage(num){
		if(this.isPortrait){
			return 'imgs/leader_tutorial_'+num+'.png';
		}else if(this.isLandscape){
			return 'imgs/leader_tutorial_'+num+'.png';
		}
	}
	adjustCSSForMobile(){
		this.isMobile = this.platform.is('mobile');
		this.isPortrait = this.platform.isPortrait();
		this.isLandscape = this.platform.isLandscape();
	  }
	


	public onClose() {
		this.audioService.playSound("SettingsOpen");
		this.navigator.dismissAll();
		this.leaderboardService.grantLeaderboardUnlockBonus().subscribe(res => {
			if(!!res){
				setTimeout(() => {
					const data: BonusContent = {
					  isAutoHideEnabled: true,
					  isAutoHideTimeout: this.autoHideCount,
					  amount: res.payload,
					  istopLeft:true,
					}
					const popoverComp = 'BonusContentPage';
					this.navigator.openPopover(popoverComp, data, "auto-dismiss-popover", true, true, true, -1, 'cover', false);
					this.balanceProvider.updateBalance();
				  }, 1500);
			}
		},err => {
			this.navigator.dismissAll();
		})
		
	}

	onSkip = () => {
		this.audioService.playSound("SettingsOpen");
		this.navigator.dismiss();
		this.leaderboardService.grantLeaderboardUnlockBonus().subscribe(res => {
			if(!!res){
				setTimeout(() => {
					const data: BonusContent = {
					  isAutoHideEnabled: true,
					  isAutoHideTimeout: this.autoHideCount,
					  amount: res.payload,
					  istopLeft:true,
					}
					const popoverComp = 'BonusContentPage';
					this.navigator.openPopover(popoverComp, data, "auto-dismiss-popover", true, true, true, -1, 'cover', false);
					this.balanceProvider.updateBalance();
				  }, 1500);
			}
		})
	}

	nextSlide(currentSlide){
		this.audioService.playSound("SettingsOpen");
		this.currentSlide = currentSlide + 1;
		setTimeout(() => {
			if(this.currentSlide !== 8){
				this.audioService.playSound("LeaderboardOpen");
			}
		}, 1000);
		// Go to Collect and Go Popup 
		if(this.currentSlide >= 8){
			// Grant LB Unlock Coins
			this.onSkip();
		}
	}

	openCancel = () => {
		this.openCancelFlag = true;
	}
	closeCancel() {
		this.openCancelFlag = false;
		this.audioService.playSound("SettingsOpen");
		this.nextSlide(this.currentSlide - 1);
	}

}
	
